export enum FONT_SIZE {
  SMALL = 'small',
  NORMAL = 'normal',
}
